'use strict';

import './vendor/prettyCheckboxes';

if ($('.checkbox-s').length > 0) {
    $('.checkbox-s').prettyCheckboxes({
        checkboxWidth: 12,
        checkboxHeight: 12,
        className: 'prettyCheckbox',
    });
}
